// LogoutPage.tsx
import React from 'react';
import { useHistory } from 'react-router-dom';

const LogoutPage: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  const history = useHistory();

  const handleLogout = () => {
    onLogout();
    history.push('/login');
    localStorage.clear();
  };

  return (
    <div>
      <h1>Logging out...</h1>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default LogoutPage;